module.exports = __webpack_public_path__ + "img/赛事系统@2x.91f7f2d6.png";